import React from 'react'
import { sanitize } from 'dompurify'

const PostDescription = post => (
  // eslint-disable-next-line
  <span className="body" dangerouslySetInnerHTML={{ __html: sanitize(post.description) }} />
)

export default PostDescription
